import React, { useState, useEffect } from 'react';
import {
    AgentsViewContainer,
    TopContent,
    BottomContent,
    LoadingContainer,
} from './AgentsViewPage.styled';
import Breadcrumb from './components/Breadcrumb/Breadcrumb';
import Header from './components/Header/Header';
import FilterBar from './components/FilterBar/FilterBar';
import { observer } from "mobx-react";
import { useStore } from '../../../hooks';
import AgentCard from './components/AgentCardContent/AgentCard';
import { CircularProgress, Typography } from '@ann/web-components';

const headers = [
    { value: 'name', label: 'Name' },
    { value: 'description', label: 'Description' },
    // { value: 'category',    label: 'Category' },
    { value: 'llmModel', label: 'Agents Using This Prompt' },
    { value: 'active', label: 'Last Updated' },
];

const AgentsViewPage = observer(() => {
    const { playgroundConfigStore } = useStore()
    const [mode, setMode] = useState('grid');
    const { agentStore } = playgroundConfigStore;




    useEffect(() => {
        agentStore.agentListStore.fetchAgentList();
        // Reset agent creation state when returning to this page
        if (agentStore.agentCreated) {
            agentStore.setAgentCreated(false);
        }
    }, []);


    return (
        <AgentsViewContainer>
            <TopContent>
                <Breadcrumb />
                <Header />
                <FilterBar mode={mode} setMode={setMode} />
            </TopContent>
            {
                agentStore.agentListStore.isLoading ? (
                    <LoadingContainer>
                        <CircularProgress size="xl" />
                    </LoadingContainer>
                ) : (
                    <>
                        <BottomContent>
                            {agentStore.agentListStore.agents.map(agent => (
                                <AgentCard key={agent.id} agent={agent} />
                            ))}
                        </BottomContent>
                    </>
                )
            }

        </AgentsViewContainer >
    );
});

export default AgentsViewPage;